import type { SharedApiCommonQueryParams } from '@izimi/api';

class SharedQueryKeys {
  private prefix = 'shared';

  getPagedSharedItems(params?: SharedApiCommonQueryParams) {
    return [this.prefix, 'paged', params].filter(Boolean);
  }

  getLastSharedItems(params?: { limit?: number }) {
    return [this.prefix, 'last-shared-items', params].filter(Boolean);
  }

  getExpiringCommunications(params?: { limit?: number }) {
    return [this.prefix, 'expiring-communications', params];
  }
}

export default SharedQueryKeys;
